// extracted by mini-css-extract-plugin
export default {"container":"u--z","productName":"v--z","price":"w--z","dimensions":"x--z"};